// Dependencies
import store from '@/store/index'

export function isLoggedIn () {
  store.commit('initialiseStore')
  return store.getters['security/isAuthenticated']
}

export function isAdmin () {
  store.commit('initialiseStore')
  return store.getters['security/isAdmin']
}

export function isManager () {
  store.commit('initialiseStore')
  return store.getters['security/hasRole']('ROLE_MANAGER')
}

export function isAdminContingents () {
  store.commit('initialiseStore')
  return store.getters['security/hasRole']('ROLE_ADMIN_CONTINGENTS')
}

export function isHotel () {
  store.commit('initialiseStore')
  return store.getters['security/hasRole']('ROLE_HOTEL')
}

export function requireAuth (to, from, next) {
  if (!isLoggedIn() || isHotel()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    if(isAdmin()) {
      next({
        path: '/admin',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  }
}

export function requireAdmin (to, from, next) {
  if (!isLoggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else if (!isAdmin()) {
    next({
      path: '/',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}

export function requireManager (to, from, next) {
  if (!isManager()) {
    next({
      path: '/home_search'
    })
  } else {
    next()
  }
}

export function redirectToHome (router) {
  if (isLoggedIn()){
    if (isAdminContingents()) {
      router.push("/admin",() => {router.go(router.currentRoute)})
    } else if (isHotel()) {
      router.push("/", () => {router.go(router.currentRoute)})
    }
  }
}

export function requireHotelAccount (to, from, next) {
  if (!isLoggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    if (isAdminContingents()) {
      next()
    } else if (isHotel()) {
      next()
    } else {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  }
}

export function requireAdminContingents (to, from, next) {
  if (!isLoggedIn() || !isAdminContingents()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}


